import type { en } from "./en";

export const it: { [K in keyof typeof en]: string } = {
  close: "Chiudi",
  howToPlay: "Come si gioca",
  dash: "Dash",
  duel: "Duello",
  ranks: "Classifica",
  garage: "Garage",
  shop: "Negozio",
  settings: "Impostazioni",
  tagline: "Corriere neon. Non crashare.",
  bestMeters: "Record {n} m · {diff}",
  pause: "Pausa",
  paused: "In pausa",
  resume: "Riprendi",
  endRun: "Termina",
  sound: "Suono",
  on: "On",
  off: "Off",
  muted: "Muto",
  muteSfx: "Silenzia musica e SFX",
  pbGhost: "Ghost PB",
  ads: "Pubblicità",
  adsOff: "Off",
  adsConsentOff: "{mode} · consenso off",
  language: "Lingua",
  langEn: "English",
  langFr: "Français",
  langIt: "Italiano",
  langEs: "Español",
  langDe: "Deutsch",
  pseudoRanks: "Pseudo (classifica)",
  pseudoHint:
    "Salvato per la classifica. Modificalo qui quando vuoi — non dopo ogni corsa. Nessun account Apple richiesto.",
  gameCenter: "Game Center",
  open: "Apri",
  gcOpening: "Apertura Game Center…",
  gcIos: "Game Center è solo per iOS.",
  gcSignIn: "Accedi a Game Center in Impostazioni, poi riprova.",
  gcHint: "Classifiche e achievement Apple. Separati dalla classifica in-app.",
  signInApple: "Accedi con Apple",
  linked: "Collegato",
  link: "Collega",
  appleLinked: "Apple collegato — la classifica segue questo ID.",
  appleLinkedWeb: "Apple collegato (test web).",
  appleWaiting: "In attesa di Apple…",
  appleCancel: "Annullato — niente collegato.",
  appleFail:
    "Apple non ha finito (spesso un ritardo di indicizzazione). Gioca con lo pseudo, riprova dopo.",
  appleHint:
    "Opzionale. Collega la classifica a questo Apple ID su tutti i dispositivi. Non serve per giocare.",
  appleLinkedHint: "ID classifica legato ad Apple. Lo pseudo sopra resta modificabile.",
  restorePurchases: "Ripristina acquisti",
  restoring: "Ripristino…",
  restored: "Acquisti ripristinati (se presenti).",
  restoreFail: "Ripristino non riuscito: {reason}",
  restoreIos: "Il ripristino è solo per iOS.",
  appleId: "Apple ID",
  adPrivacy: "Scelte pubblicità",
  manage: "Gestisci",
  privacy: "Privacy",
  support: "Supporto",
  settingsHint:
    "Swipe S/D per cambiare corsia. Swipe su per saltare — raccogli i gettoni cyan ↑ (max {n}). Il salto supera barriere, casse, buche e auto — non i camion. Garage → Mondi per Luna / Magma.",
  playingAs: "Giochi come {name}",
  noPseudo: "Nessuno pseudo — impostalo in Impostazioni",
  loading: "Caricamento…",
  noScores: "Nessun punteggio — sii #1",
  difficultyLocked: "Difficoltà bloccata per questo duello.",
  diffNote: "Medio dopo 3 corse · Difficile dopo 12. La velocità sale in corsa.",
  diffEasy: "Facile",
  diffMedium: "Medio",
  diffHard: "Difficile",
  hintEasy: "Relax",
  hintMedium: "Arcade",
  hintHard: "Insane",
  runsLeft: "{n} corse",
  runLeft: "1 corsa",
  swipeHint: "Swipe S/D · swipe su per saltare",
  swipeHintPower: " · tocca ⚡ · tieni = AUTO",
  speedUp: "SPEED UP",
  powerMagnet: "Magnete",
  powerPhase: "Fase",
  powerDefault: "Potere",
  powerOn: "ON",
  powerAuto: "AUTO",
  powerHoldHint: "Tocca per attivare · tieni per AUTO",
  powerAria: "{label}{auto} — tieni per AUTO",
  powerAriaAuto: " (auto)",
  continueAd: "Continua (pub)",
  continueFree: "Continua (gratis)",
  continueRetry: "Riprova",
  loadingAd: "Caricamento pub…",
  firstContinue: "Il primo continua è gratis.",
  adsRemovedContinue: "Pub off — continua gratis.",
  watchAd: "Guarda una pub per un’altra chance.",
  leftCount: "({n} rimasti)",
  outOfContinues: "Continua esauriti.",
  duelCrash: "Il primo crash chiude il duello.",
  adUnavailable: "Pub non disponibile — riprova o termina la corsa.",
  adsBlocked: "Pub bloccate — abilitalle in Impostazioni → Scelte pubblicità, poi riprova.",
  watchWholeAd: "Guarda tutta la pub per continuare.",
  crash: "Crash!",
  newBest: "Nuovo record!",
  runOver: "Corsa finita",
  theyCrashed: "Hanno crashato prima",
  youCrashed: "Hai crashato prima",
  deadHeat: "Pareggio",
  duelOver: "Duello finito",
  vsLasted: " — sei durato di più.",
  vsHeld: " — hanno tenuto più lontano.",
  vsSame: " — stessa distanza.",
  vsLine: "vs {name} {m} m",
  resultCoins: "+{coins} monete · Record {best} m · {diff}",
  submitting: "Invio…",
  pickPseudo: "Scegli uno pseudo per la classifica",
  offlineScore: "Offline — punteggio salvato in locale",
  rankImproved: "Globale #{rank} · {total} giocatori",
  rankBestStill: "Record ancora {best} m · #{rank}",
  choosePseudo: "Scegli il tuo pseudo",
  savePseudo: "Salva pseudo",
  asPlayer: "come {name}",
  editSettings: " · modifica in Impostazioni",
  rematch: "Rivincita",
  playAgain: "Rigioca",
  passPhone: "Passa il telefono",
  shareInvite: "Condividi / Invita",
  coinsPlus: "+{n} monete",
  menu: "Menu",
  launchBonus: "Bonus di lancio",
  welcomeTitle: "✦{n} per te",
  welcomeBody:
    "Prima apertura di questa versione — un po’ di fuel per il Garage. Una volta sola.",
  claimCoins: "Prendi ✦{n}",
  infoLead: "Corriere neon su tre corsie. Vai più lontano che puoi — non crashare.",
  controls: "Comandi",
  swipeLR: "Swipe S / D",
  swipeLRDesc: " — cambia corsia",
  swipeUp: "Swipe su",
  swipeUpDesc: " — salta (serve un gettone)",
  continueInfo: "Continua",
  continueInfoDesc: " — il primo è gratis, il secondo con pub opzionale (off in duello)",
  tapPower: "Tocca ⚡",
  tapPowerDesc: " — potere del veicolo (o tasto E)",
  twoPlayers: "A 2 giocatori",
  hotseatInfo: "Passa il telefono",
  hotseatInfoDesc:
    " — dopo una run, tocca {pass}. Stessa strada, tocca all’amico.",
  ranksDuelInfo: "Duello classifica",
  ranksDuelInfoDesc:
    " — {ranks} → {duel} su un punteggio. Corri esattamente quella strada.",
  shareInfo: "Link di invito",
  shareInfoDesc:
    " — dopo una run, {share}. L’amico apre il link e corre la tua strada.",
  twoPlayersRule:
    "Stessi ostacoli, stesso seed. Il primo crash perde — niente continue in duello.",
  boardHint:
    "Tocca {duel} su un punteggio per correre la stessa strada — il primo crash perde.",
  resultTwoP: "Gioca con un amico",
  obstacles: "Ostacoli",
  rivalBikes: "Moto rivali",
  rivalDesc: "Saltale — frenano dietro casse e barriere.",
  trucks: "Camion",
  truckDesc: "Troppo alti da saltare. Cambia corsia.",
  barriers: "Barriere",
  barrierDesc: "Saltale se hai un gettone.",
  crates: "Casse",
  crateDesc: "Il salto le supera (alcuni mezzi le distruggono).",
  collectibles: "Collezionabili",
  coinsTitle: "Monete (✦)",
  coinsDesc: "Spendile nel Garage per sbloccare i mezzi.",
  jumpTokens: "Gettoni salto",
  jumpDesc: "Accumulane fino a {n} — swipe su per usarli.",
  infoFoot:
    "La velocità sale durante la run. Scegli la difficoltà prima di Dash. {garage} = mezzi e mondi. {ranks} = punteggi e duelli. Le missioni del giorno pagano in ✦.",
  missions: "Missioni {done}/{total}",
  missionsReady: " · da prendere",
  claimed: "Preso",
  playToStreak: "Gioca per la serie",
  dayN: "Giorno {n}",
  streakClaim: "Prendi ✦{n}",
  streakToast: "Serie +✦{n}",
  missionToast: "Missione +✦{n}",
  missionClaim: "Prendi ✦{n}",
  missionDone: "Fatto",
  shopTitle: "Negozio",
  noAds: "Senza pub",
  noAdsBlurb: "Banner e interstitial off. Il ripristino funziona ancora.",
  phantomPack: "Pack Phantom GT",
  phantomPackBlurb: "Phantom GT · ✦{n} · Senza pub",
  phantomPackGranted: " — già assegnato.",
  phantomPackShort: "Pack Phantom GT · {price}",
  coinPouch: "Sacchetto monete",
  coinChest: "Forziere monete",
  coinPackBlurb: "✦{n} per auto e mondi.",
  owned: "Posseduto",
  adsRemoved: "Pub rimosse.",
  adsRemovedWeb: "Pub rimosse (test web).",
  starterUnlocked: "Starter Pack sbloccato.",
  starterUnlockedWeb: "Starter sbloccato (test web).",
  coinsGranted: "+✦{n} · saldo ✦{balance}",
  rides: "Mezzi",
  worlds: "Mondi",
  statSpeed: "Velocità",
  statJump: "Salto",
  statCoins: "Monete",
  noSpecialPower: "Nessun potere speciale",
  passive: "Passivo",
  active: "Attivo",
  equip: "Equipaggia",
  equipped: "Equipaggiato",
  tryRide: "Prova",
  tryRideHint: "Niente monete né classifica — solo un test.",
  practiceHud: "TEST",
  practiceOver: "Test drive",
  practiceNote: "Non conta — niente monete, niente classifica.",
  practiceCrash: "Test finito — niente monete, niente classifica.",
  tryAgain: "Riprova",
  backGarage: "Garage",
  getInShop: "Nel negozio",
  needMore: "Servono ancora ✦{n}",
  buyPrice: "Compra · ✦ {n}",
  haveCoins: "✦ {price} · Hai {have}",
  buyCoinsShop: "Compra monete",
  baseCoins: "Monete base",
  extraCoins: "+{pct}% monete",
  higherJump: " · salto più alto",
  jumpHoles: " · salta le buche",
  prevVehicle: "Veicolo precedente",
  nextVehicle: "Veicolo successivo",
  prevWorld: "Mondo precedente",
  nextWorld: "Mondo successivo",
  duelBanner:
    "Duello vs {name} · {m} m · {diff} · {stage} — stessa strada, il primo crash perde.",
  cancel: "Annulla",
  vsHud: "vs {name} {m}m",
  iapProductUnavailable:
    "Prodotto non disponibile: Apple non ha ancora approvato l’IAP (Ready to Submit). I prodotti esistono già — non ricrearli. Andranno in vendita dopo la review.",
  iapStoreUnavailable:
    "Store non disponibile — riprova su un dispositivo reale con un Apple ID sandbox.",
  iapFailed: "Acquisto non riuscito: {reason}",
  shareDialog: "Condividi e invita amici",
  shareCopied: "Punteggio + link di invito copiati!",
  shareNamed:
    "{who} ha dashato {meters}m{diff} in 3Dash — il primo crash perde.{challenge}",
  shareAnon:
    "Ho dashato {meters}m e preso {coins} monete in 3Dash{diff}. Batti il mio run!{challenge}",
  shareChallenge: " Stessa strada: {url}",
  mission_play3: "Finisci 3 corse",
  mission_reach400: "Raggiungi 400 m in una corsa",
  mission_coins20: "Raccogli 20 monete oggi",
  mission_jumps8: "Salta 8 volte oggi",
  mission_beatBest: "Batti il tuo record",
  veh_dash_blurb: "Hoverbike di serie. Equilibrata e gratis.",
  veh_bulldog_blurb: "Telaio pesante. Lenta, ma le casse non hanno scampo.",
  veh_falcon_blurb: "Telaio leggero, fatto per volare.",
  veh_magneto_blurb: "Aspiramonete per i farm lunghi.",
  veh_wasp_blurb: "Telaio pungiglione. Più veloce, più reattivo, zero gadget.",
  veh_phantom_blurb: "Velocità max. Attraversa tutto — per un attimo.",
  pow_none: "Nessun potere speciale.",
  pow_none_wasp: "Nessun potere — solo ritmo.",
  pow_crush: "Schiaccia le casse all’impatto. Barriere e rivali fanno ancora male.",
  pow_glider: "Aliante — salto +60% più lungo e più alto.",
  pow_magnet: "Magnete monete per 6s. Recupero 20s.",
  pow_phase: "Fase 3s — attraversa tutti gli ostacoli. Recupero 30s.",
  stage_neon: "Neon City",
  stage_lunar: "Lunar Dust",
  stage_volcano: "Magma Run",
  stage_ice: "Ice Flats",
  stage_neon_blurb: "Corsie bagnate. Il run classico di 3Dash.",
  stage_lunar_blurb: "Bassa gravità — i salti fluttuano. +25% monete.",
  stage_volcano_blurb: "Crepe di lava — salta le buche. +50% monete.",
  stage_ice_blurb: "Velocità bianca. Salti lunghi, buche di ghiaccio. +20% monete.",
};
